import { Outlet } from "react-router-dom";
import Header from './component/Header';
import Footer from './component/Footer';

function Eplayout() {
 

  

  return  (
    <div className="wrapper">
      <div id="snackbar"></div>
      <header>
        <Header /> 
      </header>
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Eplayout;
